import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from 'app/components/loader/loader.component';

@Component({
  selector: 'app-all-applications-past',
  standalone: true,
  imports: [CommonModule,LoaderComponent,TranslateModule],
  templateUrl: './all-applications-past.component.html',
  styleUrl: './all-applications-past.component.scss'
})
export class AllApplicationsPastComponent {
  @Input() pastApplications: any[] = [];
  @Output() viewDetailsClicked = new EventEmitter<string>();

  ngOnInit(){
  }

  viewAppDetails(caseId: string) {
    this.viewDetailsClicked.emit(caseId);
  }

   convertToTimeFormat(dateTimeString: string) {
        return dateTimeString.split(' ')[1];
    }

    formatDate(inputTime: string) {
        let dateObj = new Date(inputTime);
        let month = dateObj.toLocaleString('en-us', { month: 'short' });
        let day = dateObj.getDate();
        let year = dateObj.getFullYear();
        let formattedDate = day + ' ' + month + ' ' + year;

        return formattedDate;
    }
}
